"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8563],{

/***/ 76198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GetCurrentPromoMarketingUseCase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50853);
/* harmony import */ var _shared_application_GetCurrentMarketSharedUseCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34099);
/* harmony import */ var _shared_application_GetCurrentLanguageSharedUseCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85141);
/* harmony import */ var _infrastructure_HTTPMarketingRepository__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95412);







var GetCurrentPromoMarketingUseCase = /*#__PURE__*/ function() {
    "use strict";
    function GetCurrentPromoMarketingUseCase(repository, getCurrentMarketUseCase, getCurrentLanguageUseCase) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GetCurrentPromoMarketingUseCase);
        this.repository = repository;
        this.getCurrentMarketUseCase = getCurrentMarketUseCase;
        this.getCurrentLanguageUseCase = getCurrentLanguageUseCase;
    }
    var _proto = GetCurrentPromoMarketingUseCase.prototype;
    _proto.execute = function execute() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var ref, market, language, _, _tmp, promotions;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Promise.all;
                        return [
                            4,
                            _this.getCurrentMarketUseCase.execute()
                        ];
                    case 1:
                        _tmp = [
                            _state.sent()
                        ];
                        return [
                            4,
                            _this.getCurrentLanguageUseCase.execute()
                        ];
                    case 2:
                        return [
                            4,
                            _.apply(Promise, [
                                _tmp.concat(_state.sent())
                            ])
                        ];
                    case 3:
                        ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), market = ref[0], language = ref[1];
                        return [
                            4,
                            _this.repository.getActivePromotions({
                                market: market,
                                language: language
                            })
                        ];
                    case 4:
                        promotions = _state.sent();
                        return [
                            2,
                            promotions.getFirstOrEmpty()
                        ];
                }
            });
        })();
    };
    GetCurrentPromoMarketingUseCase.create = function create(param) {
        var config = param.config, repository = param.repository, marketUseCase = param.marketUseCase, languageUseCase = param.languageUseCase;
        return new GetCurrentPromoMarketingUseCase(repository !== null && repository !== void 0 ? repository : _infrastructure_HTTPMarketingRepository__WEBPACK_IMPORTED_MODULE_2__/* .HTTPMarketingRepository.create */ .w.create({
            config: config
        }), marketUseCase !== null && marketUseCase !== void 0 ? marketUseCase : _shared_application_GetCurrentMarketSharedUseCase__WEBPACK_IMPORTED_MODULE_0__["default"].create({
            config: config
        }), languageUseCase !== null && languageUseCase !== void 0 ? languageUseCase : _shared_application_GetCurrentLanguageSharedUseCase__WEBPACK_IMPORTED_MODULE_1__["default"].create({
            config: config
        }));
    };
    return GetCurrentPromoMarketingUseCase;
}();
GetCurrentPromoMarketingUseCase.USE_CASE_NAME = "GetPromoBySlugMarketingUseCase";



/***/ })

}]);